import Segment from '../shared/segment';

function Home() {
  return (
    <Segment>
      <p className='text-large'>پنل فلش کارت گروه مد مشاور</p>
      <p>به پنل فلش کارت گروه مدمشاور خوش آمدید.</p>
    </Segment>
  );
}

export default Home;
